import * as api from "./client.js";

export type PipelineStatistics = {
  enrichmentFailed: number;
  sendToApprovalFailed: number;
  pushFailed: number;
  missingNewAxisIds: number;
};

export type PipelineStatisticsFilters = {
  dateFrom?: string;
  dateTo?: string;
};

export type PipelineStatisticsResponse = {
  statistics: PipelineStatistics;
  requestId?: string;
};

export const pipelineStatistics = {
  get: async (filters?: PipelineStatisticsFilters): Promise<PipelineStatisticsResponse> => {
    const params = new URLSearchParams();
    if (filters?.dateFrom) params.append("dateFrom", filters.dateFrom);
    if (filters?.dateTo) params.append("dateTo", filters.dateTo);
    const query = params.toString() ? `?${params.toString()}` : "";
    return api.get<PipelineStatisticsResponse>(
      `/v1/content-processor/processing-items/statistics${query}`,
    );
  },
};
